export default function getLocationId(route) {
	let locationId = 0;

	if (route && route.query && route.query.lid) {
		locationId = route.query.lid;
	}

	return locationId;
}
